import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import "./admin.css";
import { useDispatch, useSelector } from "react-redux";
import adminAction from "../../redux/admin/action";
import employeeAction from "../../redux/employee/action";

export function NavbarAdmin({ setIsAdmin, authType, setAuthType }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adminStore = useSelector((state) => state.adminReducer);

  const { setAdmin } = adminAction;
  const { setEmployee } = employeeAction;

 // Debug: Log the entire notificationReducer state
  const notificationState = useSelector((state) => state.notificationReducer);
  console.log("Notification State:", notificationState);

  // Safe selector with multiple fallbacks
  const notifications = useSelector((state) => {
    // Check if notificationReducer exists and has notifications array
    if (state.notificationReducer && Array.isArray(state.notificationReducer.notifications)) {
      return state.notificationReducer.notifications;
    }
    // If notifications is not an array, return empty array
    return [];
  });

  console.log("Notifications array:", notifications);

  const unreadCount = Array.isArray(notifications) 
    ? notifications.filter(n => !n.read).length 
    : 0;


  const logout = () => {
    dispatch(setAdmin({}));
    dispatch(setEmployee({}));
    setIsAdmin(false);
    setAuthType("");
    localStorage.removeItem("admintoken");
    localStorage.removeItem("emptoken");
    navigate("/");
  };

  const isAdmin = !!localStorage.getItem("admintoken");
  

  

  return (
    <>
      {/* Topbar */}
      <nav
        className={
          "navbar navbar-expand navbar-light bg-white topbar static-top"
        }
      >
        {/* Sidebar Toggle (Topbar) */}
        {/* <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                  <i className="fa fa-bars" />
                </button> */}

        {/* Topbar Navbar */}
        <h6 className="ms-4 title">Dashboard</h6>

        <div className="ms-auto d-flex align-items-center gap-4 px-3">
          {isAdmin && (
            <div
            className="position-relative"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/admin/notifications")}
            title="Notifications"
          >
            <i className="fa-solid fa-bell fa-lg"></i>
            {unreadCount > 0 && (
              <span
                className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill"
                style={{ fontSize: "10px", padding: "4px 6px" }}
              >
                {unreadCount > 9 ? "9+" : unreadCount}
              </span>
            )}
          </div>
          )}

          <button className="dashboardBtn" onClick={logout}>
            Logout
          </button>
        </div>
      </nav>
      {/* End of Topbar */}
    </>
  );
}
